"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Scale, Stethoscope, PawPrint, HardHat, Truck, Store, Wrench, Calculator, Smile, X } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const personas = [{
  id: 1,
  icon: Scale,
  title: "ESTRUCTURALES",
  summary: "Perfiles de alta resistencia para edificaciones industriales y comerciales. Disponibles en diversas dimensiones bajo normas internacionales de calidad y seguridad estructural.",
  slug: "/Estructurales",
  idClassName: "bg-card border border-border rounded-lg p-6 flex flex-col h-full hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.46-p.m.png)]"
}, {
  id: 2,
  icon: Stethoscope,
  title: "PERFILERIA",
  summary: "Recubrimiento de zinc de primera calidad para máxima protección contra la corrosión. Ideal para techumbres y muros en ambientes industriales exigentes.",
  slug: "/PerfileriaProductos",
  idClassName: "bg-card border border-border rounded-lg p-8 flex flex-col items-center justify-center text-center aspect-square hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.55-p.m.png)]"
}, {
  id: 3,
  icon: PawPrint,
  title: "PLANOS",
  summary: "Material versátil para fabricación de maquinaria y estructuras pesadas. Corte a medida disponible para satisfacer las especificaciones exactas de su proyecto.",
  slug: "/PlanosProductos",
  idClassName: "bg-card border border-border rounded-lg p-8 flex flex-col items-center justify-center text-center aspect-square hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.01-p.m.png)]"
}, {
  id: 4,
  icon: HardHat,
  title: "POLINERIA",
  summary: "Refuerzo esencial para concreto armado. Cumple con los más altos estándares de ductilidad y resistencia para obras de infraestructura civil y minería.",
  slug: "/PolineriaProductos",
  idClassName: "bg-card border border-border rounded-lg p-8 flex flex-col items-center justify-center text-center aspect-square hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.07-p.m.png)]"
}, {
  id: 5,
  icon: Truck,
  title: "RECUBIERTOS",
  summary: "Conductos de acero al carbón con y sin costura. Soluciones robustas para el transporte de fluidos y aplicaciones estructurales en plantas de procesamiento.",
  slug: "/RecubiertosProductos",
  idClassName: "bg-card border border-border rounded-lg p-8 flex flex-col items-center justify-center text-center aspect-square hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.13-p.m.png)]"
}, {
  id: 6,
  icon: Store,
  title: "SOLIDOS",
  summary: "Ángulos, canales y soleras para herrería y construcción ligera. Acabados precisos que facilitan el soldado y ensamble en sitio para contratistas.",
  slug: "/SolidosProductos",
  idClassName: "bg-card border border-border rounded-lg p-8 flex flex-col items-center justify-center text-center aspect-square hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.18-p.m.png)]"
}, {
  id: 7,
  icon: Wrench,
  title: "TREFILADOS",
  summary: "Pisos industriales de alta seguridad con máxima capacidad de carga. Diseño que permite el paso de luz y aire, ideal para plataformas and pasarelas.",
  slug: "/TrefiladosProductos",
  idClassName: "bg-card border border-border rounded-lg p-8 flex flex-col items-center justify-center text-center aspect-square hover:border-primary hover:shadow-lg transition-all duration-300 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.23-p.m.png)]"
}, {
  id: 8,
  icon: Calculator,
  title: "TUBERIA",
  summary: "Soluciones para industrias alimentarias y químicas. Resistencia superior a la oxidación y facilidad de limpieza para entornos con altos estándares de higiene.",
  slug: "/TuberiaProductos",
  idClassName: "absolute inset-0 bg-background/40 z-0 !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.30-p.m.png)]"
}];
function SubProductsConsumer() {
  const {
    posts,
    loading
  } = usePosts();
  if (loading) {
    return <div className="col-span-full flex justify-center py-12">
      <div className="animate-spin rounded-lg h-8 w-8 border-b-2 border-primary"></div>
    </div>;
  }
  return <>
    {posts.map((post, i) => {
      const image = {
        src: post.customFields?.imagen,
        srcset: "",
        sizes: ""
      };
      return <div key={post.id} data-index={i} className="flex flex-col items-center text-center space-y-4">
          {image.src && <div className="w-full aspect-video rounded-lg overflow-hidden bg-muted">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={post.customFields?.nombre || post.title} className="w-full h-full object-cover" loading="lazy" />
            </div>}
          <div>
            <span className="text-xs font-bold text-accent uppercase tracking-wider">{post.customFields?.product_category}</span>
            <h4 className="font-default text-lg font-bold text-foreground mt-1">{post.customFields?.nombre}</h4>
          </div>
        </div>;
    })}
  </>;
}
export default function ProductGrid() {
  const [expandedIndex, setExpandedIndex] = React.useState<number | null>(null);
  const heroRef = useRevealOnScroll();
  const nineRef = useRevealOnScroll();
  const noServeRef = useRevealOnScroll();
  const ctaRef = useRevealOnScroll();
  const subProductsQuery = new WP_Query({
    post_type: 'subproducto',
    per_page: 3
  });
  return <section data-section-id="260811" id="product-grid" className="w-full bg-background text-foreground">
      
      <div ref={heroRef} className="w-full bg-primary py-16 md:py-24 lg:py-32 flex items-center justify-center bg-contain bg-center bg-no-repeat !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-22-a-las-12.01.02-p.m-scaled.png)] !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-22-a-las-12.40.04-p.m-scaled.png)]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="font-default text-4xl md:text-6xl font-bold text-white tracking-tight">
            PRODUCTOS
          </h1>
        </div>
      </div>

      
      <div ref={nineRef} className="w-full bg-muted py-12 md:py-20 flex flex-col items-center">
        <div className="max-w-6xl mx-auto px-4 w-full">
          <div className="text-center mb-12">
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {personas.map((persona, i) => {
            return <div key={persona.id} data-index={i} className="group bg-card border border-border rounded-lg overflow-hidden flex flex-col h-full hover:border-primary hover:shadow-lg transition-all duration-300">
                  <div className="relative aspect-square overflow-hidden">
                    <div className={`${persona.idClassName || ""} absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105`} />
                    <div className="absolute inset-0 bg-linear-to-t from-black/60 via-transparent to-transparent z-10" />
                  </div>

                  <div className="p-6 flex flex-col items-center text-center flex-grow">
                    <h3 className="font-default text-xl md:text-2xl font-bold mb-4 text-card-foreground">
                      <span className="text-primary mr-2">{persona.id}.</span>
                      {persona.title}
                    </h3>
                    
                    <div className="mt-auto">
                      <Link to={persona.slug} onClick={e => {
                    if (i === 0) {
                      e.preventDefault();
                      setExpandedIndex(i);
                    }
                  }} className="font-default font-bold text-primary hover:text-accent transition-colors duration-200 inline-flex items-center gap-2">
                        Ver especificaciones
                        <span>→</span>
                      </Link>
                    </div>
                  </div>
                </div>;
          })}
          </div>

          {expandedIndex !== null && <div className="mt-12 relative border-t-2 border-primary py-12 animate-in fade-in slide-in-from-top-4 duration-500">
              <Button variant="ghost" size="icon" onClick={() => setExpandedIndex(null)} className="absolute top-4 right-0 text-muted-foreground hover:text-primary">
                <X className="size-6" />
              </Button>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <PostsProvider wp_query={{
              post_type: "subproducto",
              per_page: 3
            }}>
                  <SubProductsConsumer />
                </PostsProvider>
              </div>
            </div>}
        </div>
      </div>

      <div ref={noServeRef} className="w-full bg-card py-12 md:py-20 flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="font-default text-2xl md:text-3xl font-bold text-primary mb-2">
            Nuestra Diferencia.
          </h2>
          <h3 className="font-default text-lg md:text-xl font-bold mb-6 text-accent">
            Transparencia y calidad en cada suministro.
          </h3>
          <div className="space-y-6 font-sans text-base md:text-lg text-foreground leading-relaxed">
            <p>
              No somos simplemente un intermediario. Somos un centro de servicio integral. No comprometemos la seguridad utilizando materiales sin certificación, ni ocultamos costos en cotizaciones ambiguas. Nuestra reputación se ha forjado sobre la base de la honestidad y el cumplimiento riguroso de las normas de calidad.
            </p>
            <p>Si su proyecto exige excelencia técnica, estamos listos para colaborar.</p>
          </div>
        </div>
      </div>

      <div ref={ctaRef} className="w-full bg-primary py-16 md:py-24 flex flex-col items-center justify-center">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <h2 className="font-default text-2xl md:text-3xl font-bold text-primary-foreground mb-6">
            Cotice su Proyecto.
          </h2>
          <p className="font-sans text-base md:text-lg text-primary-foreground/90 leading-relaxed mb-8">
            Si identificó los materiales necesarios para su obra, nuestro equipo de ventas está listo para brindarle una cotización competitiva. Realizamos análisis de volumen y logística para optimizar sus costos de adquisición de acero.
          </p>
          <div className="mb-8">
            <Link to="/DivisionsPage">
              <Button variant="default" className="bg-accent text-accent-foreground hover:bg-secondary hover:text-secondary-foreground border-0 shadow-md">
                Solicitar Cotización
              </Button>
            </Link>
          </div>
          <p className="font-default text-lg font-bold text-primary-foreground mb-3">
            Kalisch Acero. Fortaleza en cada estructura.
          </p>
          <p className="font-sans text-sm md:text-base text-primary-foreground/80">
            Corporativo Industrial · contacto@kalischacero.com ·
            800-ACERO-01 · www.kalischacero.com
          </p>
        </div>
      </div>
    </section>;
}